var map = {
	"./bnb.png": 54162,
	"./btc.png": 75017,
	"./doge.png": 90977,
	"./eth.png": 93317,
	"./shib.png": 76390,
	"./sol.png": 99158,
	"./trx.png": 97066,
	"./usdc.png": 12585,
	"./xrp.png": 61390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57261;